var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-container"},[_c('navBarNoLab',{attrs:{"onIndex":100}}),_c('updateBack',{attrs:{"backGroundCom":_vm.backGroundComInfo},scopedSlots:_vm._u([{key:"navList",fn:function(){return [_c('pageElement',{attrs:{"onIndex":100}})]},proxy:true}])}),_c('updateTabs'),_c('bottomWidge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }